if (!customElements.get('v5-sticky-purchase')) {
 customElements.define('v5-sticky-purchase', class extends HTMLElement {
  connectedCallback() {
   this.product = this.closest('product-info');
   this.info = this.product?.querySelector('.product__info-container');
   if (!this.info) return;
   this.button = this.querySelector('[data-sticky-add]');
   this.selector = this.querySelector('[data-sticky-select]');
   this.frame = 0;
   this.schedule = () => {
    if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
   };
   this.onSourceChange = event => {
    if (this.contains(event.target)) return;
    if (!this.applyingSelection && event.target.closest('variant-selects')) this.pendingVariant = null;
    this.schedule();
   };
   this.onSelect = () => this.selectVariant();
   this.onAdd = () => {
    const add = this.info.querySelector('button[name="add"]');
    const quantity = this.info.querySelector('input[name="quantity"]');
    if (this.pendingVariant || !add || add.disabled || add.getAttribute('aria-disabled') === 'true' || add.classList.contains('loading')) return;
    if (this.selector && this.selector.value !== this.currentVariantId()) return;
    if (quantity && !quantity.checkValidity()) {
     quantity.scrollIntoView({block:'center'});
     quantity.reportValidity();
     quantity.focus();
     return;
    }
    add.click();
    this.schedule();
   };
   this.button.addEventListener('click', this.onAdd);
   this.selector?.addEventListener('change', this.onSelect);
   this.product.addEventListener('change', this.onSourceChange);
   this.product.addEventListener('input', this.onSourceChange);
   window.addEventListener('scroll', this.schedule, {passive:true});
   window.addEventListener('resize', this.schedule, {passive:true});
   document.addEventListener('click', this.schedule, true);
   this.observer = new MutationObserver(this.schedule);
   this.observer.observe(this.info, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value']});
   this.overlayObserver = new MutationObserver(this.schedule);
   this.overlayObserver.observe(document.body,{childList:true,attributes:true,attributeFilter:['class']});
   document.querySelectorAll('cart-drawer,cart-notification,product-modal,details-modal,dialog,.mobile-facets__disclosure,#shopify-pc__banner,.jdgm-modal').forEach(el => this.overlayObserver.observe(el,{subtree:true,attributes:true,attributeFilter:['class','open','hidden','style']}));
   this.resizeObserver = new ResizeObserver(this.schedule);
   this.resizeObserver.observe(this);
   this.sync();
  }
  currentVariantId() {
   return this.info.querySelector('product-form input[name="id"]')?.value || '';
  }
  selectVariant() {
   const option = this.selector?.selectedOptions[0];
   const picker = this.info.querySelector('variant-selects');
   if (!option || option.disabled || !picker) return;
   let values;
   try { values = JSON.parse(option.dataset.optionValues); } catch { return; }
   const groups = [...picker.querySelectorAll('fieldset,.product-form__input--dropdown')].filter(group => group.querySelector('input[type="radio"],select'));
   const controls = values.map((value, index) => {
    const group = groups[index];
    const select = group?.querySelector('select');
    if (select) return [...select.options].some(item => item.value === value) ? {input:select,value} : null;
    const radio = [...group?.querySelectorAll('input[type="radio"]') || []].find(item => item.value === value);
    return radio ? {input:radio,value} : null;
   });
   if (!controls.length || controls.some(control => !control)) { this.schedule(); return; }
   let changed;
   for (const control of controls) {
    const input = control.input;
    if (input.tagName === 'SELECT') {
     if (input.value !== control.value) changed = input;
     input.value = control.value;
     for (const item of input.options) {
      if (item.value === control.value) item.setAttribute('selected', 'selected');
      else item.removeAttribute('selected');
     }
    } else {
     if (!input.checked) changed = input;
     input.checked = true;
     const selectedLabel = input.closest('.product-form__input')?.querySelector('[data-selected-value]');
     if (selectedLabel) selectedLabel.textContent = control.value;
    }
   }
   if (!changed) { this.schedule(); return; }
   this.pendingVariant = option.value;
   this.button.disabled = true;
   this.applyingSelection = true;
   changed.dispatchEvent(new Event('change', {bubbles:true}));
   this.applyingSelection = false;
   if (option.dataset.mediaId) this.product.querySelector('media-gallery')?.setActiveMedia?.(`${this.dataset.section}-${option.dataset.mediaId}`, false);
   this.schedule();
  }
  setText(selector, text) {
   const element = this.querySelector(selector);
   if (element && element.textContent !== text) element.textContent = text;
  }
  sync() {
   const add = this.info.querySelector('button[name="add"]');
   if (!add) { this.hidden = true; return; }
   const variantId = this.currentVariantId();
   if (this.pendingVariant && variantId === this.pendingVariant) this.pendingVariant = null;
   if (this.selector && !this.pendingVariant && [...this.selector.options].some(option => option.value === variantId)) this.selector.value = variantId;
   const busy = !!this.pendingVariant || add.classList.contains('loading');
   const mismatch = this.selector && this.selector.value !== variantId;
   this.button.disabled = busy || !!mismatch || add.disabled || add.getAttribute('aria-disabled') === 'true';
   this.button.setAttribute('aria-busy', String(busy));
   const label = add.querySelector('span:not(.loading__spinner)')?.textContent.trim() || add.textContent.trim();
   this.setText('[data-sticky-add]', busy ? this.dataset.busyLabel : label);
   const variant = [...this.info.querySelectorAll('variant-selects input:checked,variant-selects select')].map(input => input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.value).filter(value => value && value !== 'Default Title').join(' / ');
   const quantity = this.info.querySelector('input[name="quantity"]')?.value || '1';
   this.setText('[data-sticky-variant]', [variant, `${this.dataset.quantityLabel} ${quantity}`].filter(Boolean).join(' · '));
   const error = this.info.querySelector('.product-form__error-message');
   this.setText('[data-sticky-status]', error?.closest('[hidden]') ? '' : error?.textContent.trim() || '');
   const overlay = document.querySelector('cart-drawer.active,cart-notification.active,product-modal[open],details-modal details[open],dialog[open],.mobile-facets__disclosure[open],.menu-drawer-container[open]');
   const mobile = window.innerWidth < 990;
   const privacy = document.querySelector('#shopify-pc__banner');
   const reviewModal = document.querySelector('.jdgm-modal');
   const obscured = !!overlay || (mobile && (privacy?.getBoundingClientRect().height > 0 || reviewModal?.getBoundingClientRect().height > 0));
   const previewHeight = document.getElementById('PBarNextFrameWrapper')?.getBoundingClientRect().height || 0;
   const bottom = `${previewHeight > 0 && previewHeight < 200 ? previewHeight : 0}px`;
   if (this.style.bottom !== bottom) this.style.bottom = bottom;
   this.hidden = obscured || (!mobile && add.getBoundingClientRect().bottom > 0);
   document.documentElement.classList.toggle('v5-sticky-visible', !this.hidden);
   if (!this.hidden && mobile) {
    const space = `${Math.ceil(this.getBoundingClientRect().height) + 12}px`;
    if (document.documentElement.style.getPropertyValue('--v5-sticky-space') !== space) document.documentElement.style.setProperty('--v5-sticky-space', space);
   }
  }
  disconnectedCallback() {
   cancelAnimationFrame(this.frame);
   this.observer?.disconnect();
   this.overlayObserver?.disconnect();
   this.resizeObserver?.disconnect();
   window.removeEventListener('scroll',this.schedule);
   window.removeEventListener('resize',this.schedule);
   document.removeEventListener('click',this.schedule,true);
   this.product?.removeEventListener('change',this.onSourceChange);
   this.product?.removeEventListener('input',this.onSourceChange);
   this.button?.removeEventListener('click',this.onAdd);
   this.selector?.removeEventListener('change',this.onSelect);
   document.documentElement.classList.remove('v5-sticky-visible');
   document.documentElement.style.removeProperty('--v5-sticky-space');
  }
 });
}
// Set only the first desktop masonry window. Judge.me owns every subsequent
// height update and all review loading, sorting, filtering and photo controls.
(() => {
 const initialized = new WeakSet();
 const observeReviews = (root = document) => {
  root.querySelectorAll('.v5-reviews').forEach(section => {
   if (initialized.has(section)) return;
   initialized.add(section);
   const compact = () => {
    const grid = section.querySelector('.jdgm-masonry-grid');
    const more = grid?.querySelector('.jdgm-masonry-grid__btn');
    if (!more || !grid.style.maxHeight || !grid.querySelector('.jdgm-review-card')) return false;
    grid.style.maxHeight = `${Math.min(parseFloat(grid.style.maxHeight), matchMedia('(min-width:990px)').matches ? 390 : 520)}px`;
    return true;
   };
   if (compact()) return;
   const observer = new MutationObserver(() => { if (compact()) observer.disconnect(); });
   observer.observe(section, {childList:true, subtree:true, attributes:true, attributeFilter:['style']});
   setTimeout(() => observer.disconnect(), 30000);
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => observeReviews(), {once:true});
 else observeReviews();
 document.addEventListener('shopify:section:load', event => observeReviews(event.target));
})();

if (!customElements.get('v5-delivery-estimate')) {
 customElements.define('v5-delivery-estimate', class extends HTMLElement {
  connectedCallback() {
   this.range = this.querySelector('[data-delivery-range]');
   this.refresh = () => this.updateRange();
   document.addEventListener('visibilitychange', this.refresh);
   window.addEventListener('pageshow', this.refresh);
   this.updateRange();
  }
  updateRange() {
   clearTimeout(this.midnightTimer);
   if (!this.range) return;
   const now = new Date();
   const minimum = Number(this.dataset.minDays);
   const maximum = Number(this.dataset.maxDays);
   if (!Number.isInteger(minimum) || !Number.isInteger(maximum) || minimum < 0 || maximum < minimum) return;
   const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
   const end = new Date(start);
   start.setDate(start.getDate() + minimum);
   end.setDate(end.getDate() + maximum);
   const options = {month:'short',day:'numeric'};
   if (start.getFullYear() !== now.getFullYear() || end.getFullYear() !== now.getFullYear()) options.year = 'numeric';
   try {
    const formatter = new Intl.DateTimeFormat(this.dataset.locale || document.documentElement.lang || 'en', options);
    this.range.textContent = formatter.formatRange ? formatter.formatRange(start,end) : `${formatter.format(start)} – ${formatter.format(end)}`;
   } catch {
    this.range.textContent = `${start.toLocaleDateString('en',{month:'short',day:'numeric',year:options.year})} – ${end.toLocaleDateString('en',{month:'short',day:'numeric',year:options.year})}`;
   }
   const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()+1);
   this.midnightTimer = setTimeout(this.refresh, Math.max(1000, midnight.getTime() - now.getTime() + 1000));
  }
  disconnectedCallback() {
   clearTimeout(this.midnightTimer);
   document.removeEventListener('visibilitychange',this.refresh);
   window.removeEventListener('pageshow',this.refresh);
  }
 });
}

if (!customElements.get('v5-size-guide')) {
 customElements.define('v5-size-guide', class extends HTMLElement {
  connectedCallback() {
   this.trigger = this.querySelector('[data-size-guide-open]');
   this.dialog = this.querySelector('dialog');
   if (!this.trigger || !this.dialog || !this.dialog.showModal) return;
   this.openGuide = event => {
    event.preventDefault();
    this.dialog.showModal();
    document.documentElement.classList.add('v5-guide-open');
   };
   this.closeGuide = () => this.dialog.close();
   this.onClose = () => {
    if (!document.querySelector('.v5-size-guide-dialog[open]')) document.documentElement.classList.remove('v5-guide-open');
    this.trigger.focus({preventScroll:true});
   };
   this.backdropClick = event => {
    if (event.target !== this.dialog) return;
    const bounds = this.dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeGuide();
   };
   this.trigger.addEventListener('click',this.openGuide);
   this.closeButtons = this.querySelectorAll('[data-size-guide-close]');
   this.closeButtons.forEach(button => button.addEventListener('click',this.closeGuide));
   this.dialog.addEventListener('close',this.onClose);
   this.dialog.addEventListener('click',this.backdropClick);
  }
  disconnectedCallback() {
   this.trigger?.removeEventListener('click',this.openGuide);
   this.closeButtons?.forEach(button => button.removeEventListener('click',this.closeGuide));
   this.dialog?.removeEventListener('close',this.onClose);
   this.dialog?.removeEventListener('click',this.backdropClick);
   if (!document.querySelector('.v5-size-guide-dialog[open]')) document.documentElement.classList.remove('v5-guide-open');
  }
 });
}

if (!customElements.get('v5-cart-checkout')) {
 customElements.define('v5-cart-checkout', class extends HTMLElement {
  connectedCallback() {
   this.footer = document.getElementById('main-cart-footer');
   this.items = document.getElementById('main-cart-items');
   this.total = this.querySelector('[data-cart-sticky-total]');
   this.button = this.querySelector('[data-cart-sticky-checkout]');
   if (!this.footer || !this.items || !this.total || !this.button) return;
   this.frame = 0;
   this.checkoutBarHeight = 0;
   this.schedule = () => {
    if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
   };
   this.onCheckout = () => {
    this.sync();
    const checkout = this.footer.querySelector('#checkout');
    if (!this.button.disabled && checkout && !checkout.disabled) checkout.click();
   };
   this.button.addEventListener('click',this.onCheckout);
   this.observer = new MutationObserver(this.schedule);
   this.observer.observe(this.footer,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','disabled','aria-disabled']});
   this.observer.observe(this.items,{subtree:true,childList:true,attributes:true,attributeFilter:['class','value']});
   this.overlayObserver = new MutationObserver(this.schedule);
   this.overlayObserver.observe(document.body,{childList:true,attributes:true,attributeFilter:['class']});
   document.querySelectorAll('details-modal,dialog,.menu-drawer-container,#shopify-pc__banner,.jdgm-modal').forEach(element => this.overlayObserver.observe(element,{subtree:true,attributes:true,attributeFilter:['class','open','hidden','style']}));
   window.addEventListener('scroll',this.schedule,{passive:true});
   window.addEventListener('resize',this.schedule,{passive:true});
   this.viewport = window.visualViewport;
   this.viewport?.addEventListener('scroll',this.schedule,{passive:true});
   this.viewport?.addEventListener('resize',this.schedule,{passive:true});
   document.addEventListener('click',this.schedule,true);
   this.items.addEventListener('input',this.schedule);
   this.items.addEventListener('change',this.schedule);
   this.resizeObserver = new ResizeObserver(this.schedule);
   this.resizeObserver.observe(this);
   this.resizeObserver.observe(this.footer);
   this.sync();
  }
  isMainCheckoutFullyVisible(checkout) {
   const viewport = window.visualViewport;
   const top = viewport?.offsetTop || 0, left = viewport?.offsetLeft || 0;
   const width = viewport?.width || window.innerWidth, height = viewport?.height || window.innerHeight;
   const header = document.querySelector('.shopify-section-header-sticky:not(.shopify-section-header-hidden)');
   const headerRect = header?.getBoundingClientRect();
   const safeTop = headerRect && headerRect.top <= top && headerRect.bottom > top ? Math.max(top,headerRect.bottom) : top;
   const rect = checkout.getBoundingClientRect();
   const safeBottom = Math.min(window.innerHeight,top+height) - this.checkoutBarHeight - 12;
   return rect.width > 0 && rect.height > 0 && rect.top >= safeTop && rect.bottom <= safeBottom && rect.left >= left && rect.right <= left+width;
  }
  sync() {
   const sourceTotal = this.footer.querySelector('.totals__total-value');
   const checkout = this.footer.querySelector('#checkout');
   const sourceText = sourceTotal?.textContent.trim();
   if (sourceText && this.total.textContent !== sourceText) this.total.textContent = sourceText;
   const pendingQuantity = [...this.items.querySelectorAll('input[name="updates[]"]')].some(input => input.value !== input.getAttribute('value'));
   const busy = this.items.classList.contains('cart__items--disabled') || pendingQuantity;
   const disabled = busy || !checkout || checkout.disabled || checkout.getAttribute('aria-disabled') === 'true';
   if (this.button.disabled !== disabled) this.button.disabled = disabled;
   const busyValue = String(busy);
   if (this.button.getAttribute('aria-busy') !== busyValue) this.button.setAttribute('aria-busy',busyValue);
   const privacy = document.querySelector('#shopify-pc__banner');
   const review = document.querySelector('.jdgm-modal');
   const overlay = document.querySelector('details-modal details[open],dialog[open],.menu-drawer-container[open],cart-drawer.active,cart-notification.active');
   const hasItems = !!this.items.querySelector('.cart-item') && !this.footer.classList.contains('is-empty');
   const obscured = !!overlay || privacy?.getBoundingClientRect().height > 0 || review?.getBoundingClientRect().height > 0;
   const eligible = window.innerWidth < 990 && hasItems && !!sourceTotal && !!checkout && !obscured;
   if (eligible) {
    const measuredHeight = this.getBoundingClientRect().height;
    if (measuredHeight > 0) this.checkoutBarHeight = measuredHeight;
    if (!this.checkoutBarHeight) {
     const inner = this.querySelector('.v5-cart-checkout-inner'), innerStyle = inner ? getComputedStyle(inner) : null;
     this.checkoutBarHeight = (parseFloat(getComputedStyle(this.button).minHeight) || 48) + (parseFloat(innerStyle?.paddingTop) || 10) + (parseFloat(innerStyle?.paddingBottom) || 10) + (parseFloat(getComputedStyle(this).borderTopWidth) || 0);
    }
    const space = `${Math.ceil(this.checkoutBarHeight)+12}px`;
    if (document.documentElement.style.getPropertyValue('--v5-cart-sticky-space') !== space) document.documentElement.style.setProperty('--v5-cart-sticky-space',space);
   }
   const hidden = !eligible || this.isMainCheckoutFullyVisible(checkout);
   if (this.hidden !== hidden) this.hidden = hidden;
   document.documentElement.classList.toggle('v5-cart-sticky-visible',eligible);
  }
  disconnectedCallback() {
   cancelAnimationFrame(this.frame);
   this.observer?.disconnect();
   this.overlayObserver?.disconnect();
   this.resizeObserver?.disconnect();
   this.button?.removeEventListener('click',this.onCheckout);
   this.items?.removeEventListener('input',this.schedule);
   this.items?.removeEventListener('change',this.schedule);
   window.removeEventListener('scroll',this.schedule);
   window.removeEventListener('resize',this.schedule);
   this.viewport?.removeEventListener('scroll',this.schedule);
   this.viewport?.removeEventListener('resize',this.schedule);
   document.removeEventListener('click',this.schedule,true);
   document.documentElement.classList.remove('v5-cart-sticky-visible');
   document.documentElement.style.removeProperty('--v5-cart-sticky-space');
  }
 });
}
